import memoize from 'lodash/memoize';
import { selectPagination } from 'redux/helpers/pagination';
import { createSelector } from 'reselect';


const getPageEntities = ({ entities: { pages } }) => pages;

const getPageSelector = createSelector(
  [getPageEntities],
  (entities) => memoize(id => entities?.[id]),
);

const getPagesPagination = ({ pages: { allPages } }) => selectPagination(allPages, null, 'pageIds');
const getPages = createSelector(
  [getPagesPagination, getPageSelector],
  ({ pageIds }, getPage) => pageIds.map(getPage),
);

const getPageCategoryEntities = ({ entities: { pageCategories } }) => pageCategories;
const getAllCategories = ({ pages: { allCategories } }) => allCategories;

const getCategorySelector = createSelector(
  [getPageCategoryEntities],
  (entities) => memoize(id => entities?.[id]),
);

const getSortedCategories = createSelector(
  [getAllCategories, getCategorySelector],
  (categoryIds, getCategory) => categoryIds.map(getCategory),
);

const getKnowledgeHubCategoryIds = ({ pages: { knowledgeHubCategories } }) => knowledgeHubCategories;
const getKnowledgeHubCategories = createSelector(
  [getKnowledgeHubCategoryIds, getCategorySelector],
  (categoryIds, getCategory) => categoryIds.map(getCategory),
);

const getKnowledgeHubRootPageIds = ({ pages: { knowledgeHubRootPages } }) => knowledgeHubRootPages;
const getKnowledgeHubRootPages = createSelector(
  [getKnowledgeHubRootPageIds, getPageSelector],
  (rootPageIds, getPage) => rootPageIds.map(getPage),
);


export default {
  getPageSelector,

  getPagesPagination,
  getPages,

  getCategorySelector,
  getSortedCategories,

  getKnowledgeHubCategories,
  getKnowledgeHubRootPages,
};
